import { lazy } from 'react';

export const ResetPasswordPageLazy = lazy(
    () => import('./reset-password-page'),
);
